import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-long-description',
  templateUrl: './long-description.component.html',
  styleUrls: ['./long-description.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom

})
export class LongDescriptionComponent implements OnInit {
  @Input() long_description: any
  constructor(private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
  }
  transform(value: any) {
    console.log("SANITIZING");
    return this.sanitizer.bypassSecurityTrustHtml(value);
  }

}
